<template><div><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-o{n}</code> to change the opacity of your element.</p>
<code-example source-code='&lt;div class=&quot;d-p-200 d-bar-400 d-bgc-moderate d-o100&quot;&gt;.d-o100&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bar-400 d-bgc-moderate d-o75&quot;&gt;.d-o75&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bar-400 d-bgc-moderate d-o50&quot;&gt;.d-o50&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bar-400 d-bgc-moderate d-o25&quot;&gt;.d-o25&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bar-400 d-bgc-moderate d-o0&quot;&gt;.d-o0&lt;/div&gt;'>
<dt-stack data-demo-wrapper direction="row" gap="200">
  <div class="d-p-200 d-bar-400 d-bgc-moderate d-o100">.d-o100</div>
  <div class="d-p-200 d-bar-400 d-bgc-moderate d-o75">.d-o75</div>
  <div class="d-p-200 d-bar-400 d-bgc-moderate d-o50">.d-o50</div>
  <div class="d-p-200 d-bar-400 d-bgc-moderate d-o25">.d-o25</div>
  <div class="d-p-200 d-bar-400 d-bgc-moderate d-o0">.d-o0</div>
</dt-stack>
</code-example>
<h2 id="hover" tabindex="-1" class="d-docsite--header-2">Hover <a class="header-anchor d-link d-docsite--link d-link" href="#hover" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>h:d-o{n}</code> to change an element's :hover state opacity.</p>
<code-example source-code='&lt;dt-button kind=&quot;unstyled&quot; class=&quot;d-p-200 d-bar-400 d-bgc-moderate h:d-o50&quot;&gt;Hover me&lt;/dt-button&gt;'>
<dt-button kind="unstyled" class="d-p-200 d-bar-400 d-bgc-moderate h:d-o50">Hover me</dt-button>
</code-example>
<h2 id="focus" tabindex="-1" class="d-docsite--header-2">Focus <a class="header-anchor d-link d-docsite--link d-link" href="#focus" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>f:d-o{n}</code> to change an element's :focus and :focus-within state opacity.</p>
<code-example source-code='&lt;dt-button kind=&quot;unstyled&quot; class=&quot;d-p-200 d-bar-400 d-bgc-moderate f:d-o50&quot;&gt;Focus me&lt;/dt-button&gt;'>
<dt-button kind="unstyled" class="d-p-200 d-bar-400 d-bgc-moderate f:d-o50">Focus me</dt-button>
</code-example>
<h2 id="focus-visible" tabindex="-1" class="d-docsite--header-2">Focus Visible <a class="header-anchor d-link d-docsite--link d-link" href="#focus-visible" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>fv:d-o{n}</code> to change an element's :focus-visible state opacity [only when focused by keyboard].</p>
<code-example source-code='&lt;dt-button kind=&quot;unstyled&quot; class=&quot;d-p-200 d-bar-400 d-bgc-moderate fv:d-o50&quot;&gt;Keyboard focus me&lt;/dt-button&gt;'>
<dt-button kind="unstyled" class="d-p-200 d-bar-400 d-bgc-moderate fv:d-o50">Keyboard focus me</dt-button>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="{className, value} in opacities">
        <th scope="row" class="d-code--sm d-docsite-code">.d-o{{className}}</th>
        <td class="d-code--sm">opacity: {{value}} !important;</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  const opacities = [
    {className: 0, value: 0},
    {className: 5, value: 0.05},
    {className: 10, value: 0.1},
    {className: 20, value: 0.2},
    {className: 25, value: 0.25},
    {className: 30, value: 0.3},
    {className: 40, value: 0.4},
    {className: 50, value: 0.5},
    {className: 60, value: 0.6},
    {className: 70, value: 0.7},
    {className: 75, value: 0.75},
    {className: 80, value: 0.8},
    {className: 90, value: 0.9},
    {className: 100, value: 1},
    {className: '-unset', value: 'unset'}
  ];
</script>